export default __webpack_public_path__ + "static/media/01-min.4447abb0.jpg";